export const phoneRegex = /^0\d{8,10}$/;
export const onlyNumberRegex = /^\d+$/;
export const zenkakuRegex = /^[^\x01-\x7E\uFF65-\uFF9F\u002D]+$/;
export const zenkakuKanaRegex = /^[\u30a1-\u30f6\u30fc]+$/;
export const mailRegex = /^[A-Za-z0-9]{1}[A-Za-z0-9+_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
